import React from 'react';
import { Button, Glyphicon } from 'react-bootstrap';

const EditButton = props => (
	<Button bsSize='xsmall' {...props}>
		<Glyphicon glyph='pencil'/> Éditer
	</Button>
);

export default EditButton;